/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Downloadlinksarchivedbadge3Inputs */

const en_downloadlinksarchivedbadge3 = /** @type {(inputs: Downloadlinksarchivedbadge3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archived`)
};

const de_downloadlinksarchivedbadge3 = /** @type {(inputs: Downloadlinksarchivedbadge3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archiviert`)
};

/**
* | output |
* | --- |
* | "Archived" |
*
* @param {Downloadlinksarchivedbadge3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const downloadlinksarchivedbadge3 = /** @type {((inputs?: Downloadlinksarchivedbadge3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloadlinksarchivedbadge3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_downloadlinksarchivedbadge3(inputs)
	return de_downloadlinksarchivedbadge3(inputs)
});
export { downloadlinksarchivedbadge3 as "downloadLinksArchivedBadge" }